export const BUFFER_PERCENTAGE = 5;
